import styled from 'styled-components';
import { Swiper as SwiperType } from 'swiper';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';

import { DefaultButtonStyled } from '@/components/atom/buttons/DefaultButton';
import Delete from '@/components/atom/icon/Delete';
import PageDot from '@/components/atom/icon/PageDot';
import Overlay from '@/components/molecules/Overlay';
import PresignedImage from '@/components/molecules/PresignedImage';
import theme from '@/styles/theme';
import { AttachmentBlindType } from '@/types/bff/gql-schema';
import { QnaAttachment } from '@/types/qna';

export interface Image {
  src: string;
  blindType?: AttachmentBlindType;
}
export interface ImageSwiperProps {
  images: Array<QnaAttachment>;
  initialIndex?: number;
  onClose: () => void;
  isMine: boolean;
  imageSlideIdx: number;
  onChangeImageBlindType: (index: number) => void;
  onChangeSlideImage: (swiper: SwiperType) => void;
}

const QnaAttachmentsSwiper = ({
  images,
  initialIndex,
  onClose,
  isMine,
  imageSlideIdx,
  onChangeImageBlindType,
  onChangeSlideImage,
}: ImageSwiperProps) => {
  return (
    <ImageSwiperWrapper index={10} onClickOverlay={onClose}>
      <SwiperSlideWrapper>
        <Close onClick={onClose}>
          <Delete size={16} />
        </Close>
        <Swiper
          slidesPerView={1}
          loop={images.length > 1}
          style={{ width: '100%' }}
          initialSlide={initialIndex ?? imageSlideIdx}
          onSlideChange={onChangeSlideImage}
        >
          {images.map((image, index) => (
            <SwiperSlide key={`image-${index}`} style={{ alignSelf: 'center' }}>
              <ImageWrapper onClick={() => onChangeImageBlindType(index)}>
                <QuestionImage attachmentId={image.questionAttachmentId} />
                {!isMine && image.blindType === AttachmentBlindType.Dimmed && (
                  <ImageDimmed />
                )}
              </ImageWrapper>
            </SwiperSlide>
          ))}
        </Swiper>
        <ImagePaging>
          {images.map((_, key) => (
            <PageDot
              color={
                imageSlideIdx === key
                  ? theme.color.primary500
                  : theme.color.gray500
              }
              key={key}
            />
          ))}
        </ImagePaging>
      </SwiperSlideWrapper>
    </ImageSwiperWrapper>
  );
};

export default QnaAttachmentsSwiper;

const ImageSwiperWrapper = styled(Overlay)``;

const SwiperSlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  max-width: 768px;
`;

const ImagePaging = styled.div`
  display: flex;
  padding: 8px 12px;
  margin-top: 16px;
  border-radius: 16px;
  gap: 6px;

  ${({ theme }) => `
    background: ${theme.color.black};
  `};
`;

const ImageWrapper = styled.div`
  max-width: ${({ theme }) => theme.size.tablet};
  display: flex;
  justify-content: center;
  width: 100%;
  max-height: 60vh;
  margin: auto;
`;

const QuestionImage = styled(PresignedImage)`
  width: 100%;
  object-fit: contain;
`;

const Close = styled(DefaultButtonStyled)`
  margin: 0 16px 16px auto;
  background: ${({ theme }) => theme.color.dimmed40};
  border-radius: 4px;
  width: 40px;
  height: 40px;
`;

const ImageDimmed = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.dimmed40};
  position: absolute;
  top: 0;
`;
